module.exports = __webpack_public_path__ + "static/img/kf.2c37051.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kf.png
// module id = 7LJF
// module chunks = 0